var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 96,
    viewBox: "0 0 128 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5322_96461)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.867 28.3845C115.165 32.2824 122.86 42.4768 122.96 56.669C122.96 61.6662 123.059 70.0616 116.964 77.1577C110.768 84.2538 100.275 87.8518 92.08 85.3532C86.9833 83.854 87.7828 81.4553 81.1872 78.9567C80.0879 78.5569 67.3963 73.8595 59.1018 79.9562C56.2037 82.055 56.8033 83.3543 53.9052 86.5525C53.3056 87.2521 43.612 97.7464 30.2208 95.7475C19.8277 94.2483 11.1335 85.653 9.53451 76.8579C8.83498 72.96 9.53451 69.362 10.1341 66.3636C11.5332 59.3675 13.7317 58.2681 15.5306 51.4718C16.1302 49.373 17.6292 43.3763 16.5299 36.1802C15.2307 27.7849 11.7331 27.1852 11.7331 21.0886C11.6331 15.0919 14.9309 7.09626 22.2261 3.99796C28.1222 1.49934 35.3175 2.59873 39.5147 6.39664C41.4134 8.19565 41.4134 9.29505 42.9125 11.5938C47.9092 18.9897 57.5028 20.8887 63.9985 22.2879C67.9959 23.0875 77.4896 24.9864 87.2831 21.4883C89.0819 20.8887 89.1819 20.5888 90.481 20.289C98.1759 18.49 106.171 23.5872 111.867 28.3845Z",
    fill: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34.4186 22.7909C33.0195 22.7909 31.8203 21.6915 31.8203 20.1923C31.8203 18.6931 32.9196 17.5938 34.4186 17.5938C35.8177 17.5938 37.0169 18.6931 37.0169 20.1923C37.0169 21.6915 35.8177 22.7909 34.4186 22.7909ZM34.4186 18.6931C33.5192 18.6931 32.8197 19.3928 32.8197 20.2923C32.8197 21.1918 33.5192 21.8914 34.4186 21.8914C35.318 21.8914 36.0175 21.1918 36.0175 20.2923C36.0175 19.3928 35.318 18.6931 34.4186 18.6931Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.762 69.2631C121.763 69.2631 120.164 67.564 120.164 65.5651C120.164 63.5662 121.763 61.8672 123.762 61.8672C125.76 61.8672 127.359 63.5662 127.359 65.5651C127.359 67.564 125.76 69.2631 123.762 69.2631ZM123.762 62.8666C122.263 62.8666 121.063 64.066 121.063 65.5651C121.063 67.0643 122.263 68.2637 123.762 68.2637C125.261 68.2637 126.46 67.0643 126.46 65.5651C126.46 64.066 125.261 62.8666 123.762 62.8666Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.47 45.2772C107.171 45.2772 106.172 44.2777 106.172 42.9784C106.172 41.6791 107.171 40.6797 108.47 40.6797C109.77 40.6797 110.769 41.6791 110.769 42.9784C110.769 44.2777 109.77 45.2772 108.47 45.2772ZM108.47 41.6791C107.771 41.6791 107.171 42.2788 107.171 42.9784C107.171 43.678 107.771 44.2777 108.47 44.2777C109.17 44.2777 109.77 43.678 109.77 42.9784C109.77 42.2788 109.17 41.6791 108.47 41.6791Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M4.13541 49.168C3.73567 49.168 3.33594 48.8682 3.33594 48.3685V42.9714C3.33594 42.5717 3.63574 42.1719 4.13541 42.1719C4.63508 42.1719 4.93488 42.4717 4.93488 42.9714V48.3685C4.93488 48.8682 4.53514 49.168 4.13541 49.168Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.7366 46.4741H1.4401C1.04036 46.4741 0.640625 46.1743 0.640625 45.6746C0.640625 45.1748 0.940427 44.875 1.4401 44.875H6.7366C7.13633 44.875 7.53607 45.1748 7.53607 45.6746C7.53607 46.1743 7.23627 46.4741 6.7366 46.4741Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M23.2213 89.0508C22.8216 89.0508 22.4219 88.751 22.4219 88.2513V82.8543C22.4219 82.4545 22.7217 82.0547 23.2213 82.0547C23.721 82.0547 24.0208 82.3545 24.0208 82.8543V88.2513C24.0208 88.751 23.6211 89.0508 23.2213 89.0508Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.8225 86.3491H20.526C20.1263 86.3491 19.7266 86.0493 19.7266 85.5496C19.7266 85.0498 20.0264 84.75 20.526 84.75H25.8225C26.2223 84.75 26.622 85.0498 26.622 85.5496C26.622 86.0493 26.3222 86.3491 25.8225 86.3491Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M18.8278 5.49697C18.528 5.49697 18.3281 5.29708 18.3281 4.99725V0.499725C18.3281 0.19989 18.528 0 18.8278 0C19.1276 0 19.3275 0.19989 19.3275 0.499725V4.99725C19.3275 5.29708 19.0277 5.49697 18.8278 5.49697Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.9296 3.20258H16.6325C16.3327 3.20258 16.1328 3.00269 16.1328 2.70285C16.1328 2.40301 16.3327 2.20312 16.6325 2.20312H20.9296C21.2294 2.20312 21.4293 2.40301 21.4293 2.70285C21.4293 3.00269 21.2294 3.20258 20.9296 3.20258Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M110.57 84.7548C110.27 84.7548 110.07 84.5549 110.07 84.2551V79.7575C110.07 79.4577 110.27 79.2578 110.57 79.2578C110.87 79.2578 111.07 79.4577 111.07 79.7575V84.2551C111.07 84.5549 110.87 84.7548 110.57 84.7548Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.766 82.562H108.468C108.169 82.562 107.969 82.3621 107.969 82.0622C107.969 81.7624 108.169 81.5625 108.468 81.5625H112.766C113.065 81.5625 113.265 81.7624 113.265 82.0622C113.265 82.3621 113.065 82.562 112.766 82.562Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M108.468 13.6947C107.868 13.6947 107.469 13.2949 107.469 12.6952V4.99945C107.469 4.39978 107.868 4 108.468 4C109.068 4 109.467 4.39978 109.467 4.99945V12.6952C109.467 13.1949 108.968 13.6947 108.468 13.6947Z",
    fill: "#074177"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.168 9.79577H104.773C104.173 9.79577 103.773 9.39599 103.773 8.79632C103.773 8.19665 104.173 7.79688 104.773 7.79688H112.168C112.768 7.79688 113.167 8.19665 113.167 8.79632C113.167 9.39599 112.768 9.79577 112.168 9.79577Z",
    fill: "#074177"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.37 74.0688L60.2738 77.95C60.7254 78.6576 61.348 79.24 62.0842 79.6434C62.8203 80.0468 63.6462 80.2583 64.4856 80.2583C65.3251 80.2583 66.151 80.0468 66.8871 79.6434C67.6232 79.24 68.2459 78.6576 68.6975 77.95L71.6013 74.0688C72.0392 73.4268 72.6192 72.8944 73.2963 72.5131C73.9734 72.1317 74.7293 71.9117 75.5053 71.8699C76.2812 71.8282 77.0564 71.966 77.7704 72.2725C78.4845 72.5791 79.1183 73.0462 79.6225 73.6375C84.74 79.1 88.9087 77.2887 88.9087 69.6412V37.24C88.9375 25.6537 86.235 22.75 75.3675 22.75H53.6325C42.765 22.75 40.0625 25.6537 40.0625 37.24V69.6125C40.0625 77.2887 44.26 79.0713 49.3488 73.6375C49.853 73.0462 50.4867 72.5791 51.2008 72.2725C51.9149 71.966 52.69 71.8282 53.466 71.8699C54.242 71.9117 54.9979 72.1317 55.675 72.5131C56.3521 72.8944 56.9321 73.4268 57.37 74.0688V74.0688Z",
    stroke: "#074177",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.625 48.625H76",
    stroke: "#074177",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.625 37.125H76",
    stroke: "#074177",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 48.625H53.0259",
    stroke: "#074177",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 37.125H53.0259",
    stroke: "#074177",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5322_96461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGrey);
export default __webpack_public_path__ + "static/media/error-grey.b5b2504907cf59948e90e741ca4628fd.svg";
export { ForwardRef as ReactComponent };